<script>

    export let textString = '';

    // Match groups of consecutive tokens that Unicode categorises as letters and numbers.
    // See https://www.unicode.org/Public/UCD/latest/ucd/PropertyValueAliases.txt for a list of
    // all Unicode categories and https://javascript.info/regexp-unicode for examples how to use these.
    $: wordCount = (textString.match(/[\p{L}\p{N}]+/ug) || []).length;
</script>

<div class="counter">
    {window.i18n.sprintf(window.i18n.ngettext('%s word', '%s words', wordCount), wordCount)}
</div>

<style lang="scss">

    .counter {
        @include normal-text;
        text-align: right;
        margin-top: 4px;
        color: $blue-black-50;
    }

</style>
